import React from 'react';
import bem from 'utils/bem';
import CheckboxHTMLField from 'forms/fields/CheckboxField/CheckboxHTMLField';
import FormikCheckboxField from 'forms/fields/CheckboxField/FormikCheckboxField';
import { docs } from 'components/Footer/credentials';
import './index.sass';

const { cnBlock } = bem('user-agreement-field');
const UserAgreementCheckboxField = ({ className, name, mod, ...rest }) => {
    const siteVersion = window.isRuDomain ? 'ru' : 'kz';
    const siteDocs = docs[siteVersion]

    const confidentLink = siteDocs['confidentLink'];
    const userAgreementLink = siteDocs['userAgreementLink'];

    const text = mod === 'short' ?
        `Согласие на обработку <a href=${userAgreementLink} target='_blank'>персональных данных</a>` :
        `Я ознакомлен с <a href=${confidentLink} target='_blank'>Политикой конфиденциальности</a>\n и даю согласие на обработку <a href="${userAgreementLink}" target='_blank'>персональных данных</a>`;

    return (
        <FormikCheckboxField Checkbox={CheckboxHTMLField} className={ cnBlock(className) } name={name} text={ text } { ...rest }/>
    );
};

export default UserAgreementCheckboxField;
